module.exports = __webpack_public_path__ + "static/media/elchivo.8b84db95.jpg";